/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from "react";
import { withTranslation } from "react-i18next";
import i18n from "../../i18n";
import {
  Cell,
  Legend,
  Pie,
  PieChart,
  ResponsiveContainer,
  Sector,
  Tooltip,
} from "recharts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReadFriendlyNumber } from "../../lib/utils";

interface AggregatedYear {
  academicYearKey: string; // t.ex. "2021-09_2022-08"
  label: string;           // t.ex. "2021/2022"
  reportsExpected: number;
  reportsReceived: number;
}

interface ICalendarYearPieProps {
  data?: AggregatedYear[];
  onSelectedSlice:(selectedAcademicyear:string) => void;
}

interface ICalendarYearPieState {
  activeIndex: number;
  width: number;
  height: number;
  yearIndex: number; // 0-based index i data
}

class CalendarYearPie extends React.Component<
  ICalendarYearPieProps,
  ICalendarYearPieState
> {
  placeHolder: any[] = [{ name: "", value: 100 }];

  constructor(props: ICalendarYearPieProps) {
    super(props);
    this.state = {
      activeIndex: -1,
      width: window.innerWidth,
      height: window.innerHeight,
      yearIndex: 0,
    };
  }

  componentDidMount(): void {
    window.addEventListener("resize", this.HandleRezise);
    const len = this.props.data?.length ?? 0;
    if (len > 0) {
      this.setState({ yearIndex: len - 1 }); // starta på senaste år
    }
  }

  componentDidUpdate(prevProps: ICalendarYearPieProps): void {
    const prevLen = prevProps.data?.length ?? 0;
    const currLen = this.props.data?.length ?? 0;

    if (currLen > 0 && prevLen !== currLen) {
      this.setState((prev) => ({
        yearIndex: Math.min(prev.yearIndex, currLen - 1),
      }));
    }
  }

  componentWillUnmount(): void {
    window.removeEventListener("resize", this.HandleRezise);
  }

  HandleRezise = () => {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  };

  CustomActiveShape: any = (shape: any): any => {
    const {
      cx,
      cy,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload
    } = shape;

    return (
      <g>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius + 5}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
          style={{ opacity: "0.8", cursor: "pointer" }}
          onMouseLeave={() => this.setState({ activeIndex: -1 })}
          onClick={() => this.props.onSelectedSlice(payload.payload)}
        />
      </g>
    );
  };

  CustomToolTip: any = ({ active, payload }: any): any => {
    if (!active || !payload || !payload.length) return null;

    const d = payload[0].payload as {
      name: string;
      value: number;
      expected: number;
    };

    const total = d.expected;
    const percent = total > 0 ? (d.value / total) * 100 : 0;

    return (
      <div
        style={{
          borderRadius: "5px",
          backgroundColor: "#fcfbfa",
          textAlign: "center",
          padding: "4px 8px",
        }}
      >
        <b>{d.name}</b>
        <p style={{ margin: 0 }}>
          {ReadFriendlyNumber(d.value)} / {ReadFriendlyNumber(total)} (
          {percent.toFixed(1)}%)
        </p>
      </div>
    );
  };

  CustomLegend: any = (props: any): any => {
    const { payload } = props;
    if (!payload || !payload.length) return null;

    return (
      <div className="pieLegend">
        <table>
          <tbody>
            {payload.map((entry: any, index: number) => (
              <tr key={`legend-${index}`}>
                <td>
                  <FontAwesomeIcon
                    style={{
                      color: entry.color,
                      paddingRight: 5,
                      marginLeft: 15,
                      paddingBottom: 2,
                    }}
                    icon={"square"}
                  />
                  {entry.payload.name}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  handleBackward = () => {
    const len = this.props.data?.length ?? 0;
    if (len === 0) return;

    this.setState((prev) => ({
      yearIndex: Math.max(0, prev.yearIndex - 1),
    }));
  };

  handleForward = () => {
    const len = this.props.data?.length ?? 0;
    if (len === 0) return;

    this.setState((prev) => ({
      yearIndex: Math.min(len - 1, prev.yearIndex + 1),
    }));
  };

  render() {
    const data = this.props.data ?? [];
    const hasData = data.length > 0;

    const safeIndex =
      data.length > 0
        ? Math.min(Math.max(this.state.yearIndex, 0), data.length - 1)
        : 0;

    const selectedYear = hasData ? data[safeIndex] : null;
    const expected = Number(selectedYear?.reportsExpected ?? 0);
const receivedRaw = Number(selectedYear?.reportsReceived ?? 0);
const received = Math.min(receivedRaw, expected);
const missing = Math.max(expected - received, 0);

    console.log("Year", selectedYear?.label, { expected, receivedRaw, received, missing });

    // const pieData = selectedYear
    //   ? [
    //       {
    //         name: i18n.t("dashboard.reported") || "Rapporterade",
    //         value: selectedYear.reportsReceived,
    //         expected: selectedYear.reportsExpected,
    //         period:selectedYear.label
    //       },
    //       {
    //         name: i18n.t("dashboard.not_reported") || "Ej rapporterade",
    //         value: Math.max(
    //           selectedYear.reportsExpected - selectedYear.reportsReceived,
    //           0
    //         ),
    //         expected: selectedYear.reportsExpected,
    //         period:selectedYear.label
    //       },
    //     ]
    //   : [];
    const pieData = selectedYear
  ? [
      {
        name: i18n.t("dashboard.reported") || "Rapporterade",
        value: received,
        expected,
        period: selectedYear.label,
      },
      {
        name: i18n.t("dashboard.not_reported") || "Ej rapporterade",
        value: missing,
        expected,
        period: selectedYear.label,
      },
    ]
  : [];

    const isFirst = safeIndex === 0;
    const isLast = data.length > 0 && safeIndex === data.length - 1;

    return (
      <div
        style={{
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          display: "flex",
          flex: 1,
          borderRadius: "5px",
          position: "relative",
        }}
      >
        {hasData && selectedYear ? (
          <ResponsiveContainer
            width={
              this.state.width <= 600
                ? `${this.state.width / 3.8}%`
                : `${this.state.width / 2.5}%`
            }
            height={
              this.state.height <= 800
                ? this.state.height + 30
                : this.state.height / 1.8
            }
          >
            <PieChart margin={{}}>
              <Pie
                data={pieData}
                activeIndex={this.state.activeIndex}
                activeShape={this.CustomActiveShape}
                labelLine={false}
                innerRadius={0}
                outerRadius={
                  this.state.width >= 200 && this.state.width <= 300
                    ? 60
                    : this.state.width <= 600
                    ? 125
                    : this.state.width <= 1400
                    ? this.state.width / 10
                    : this.state.width / 11
                }
                dataKey="value"
                onMouseEnter={(_, index) =>
                  this.setState({ activeIndex: index })
                }
                style={{ outline: "none" }}
              >
                {pieData.map((slice, index) => (
                  <Cell
                    key={`slice-${slice.name}-${index}`}
                    style={{ opacity: 0.7, outline: "none" }}
                    fill={index === 0 ? "#8fa9ba" : "#173d54"} 
                  />
                ))}
              </Pie>
              <Tooltip content={this.CustomToolTip} />
              <Legend
                verticalAlign="bottom"
                wrapperStyle={{ paddingLeft: "5px", display: "block" }}
                content={this.CustomLegend}
              />
            </PieChart>
          </ResponsiveContainer>
        ) : (
          <ResponsiveContainer
            width={`${this.state.width / 2.5}%`}
            height={this.state.height / 2}
          >
            <PieChart>
              <Pie
                data={this.placeHolder}
                labelLine={true}
                innerRadius={0}
                outerRadius={
                  this.state.width <= 900 ? 70 : this.state.width / 17
                }
                fill="#dddd"
                dataKey="value"
              />
              <Legend
                verticalAlign="bottom"
                wrapperStyle={{ display: "block" }}
                content={this.CustomLegend}
              />
            </PieChart>
          </ResponsiveContainer>
        )}

        {selectedYear && (
          <div
            style={{
              position: "absolute",
              right: 8,
              top: 5,
              display: "flex",
              alignItems: "center",
              gap: 6,
              fontSize: "0.8rem",
              color: "#4b5563",
              background: "rgba(255,255,255,0.85)",
              borderRadius: 4,
              padding: "2px 4px",
            }}
          >
            <FontAwesomeIcon
              onClick={() => !isFirst && this.handleBackward()}
              style={
                isFirst
                  ? { color: "#dddd" }
                  : { color: "#173C53", cursor: "pointer" }
              }
              size="sm"
              icon={"arrow-alt-circle-left"}
            />
            <span>{selectedYear.label}</span>
            <FontAwesomeIcon
              onClick={() => !isLast && this.handleForward()}
              style={
                isLast
                  ? { color: "#dddd" }
                  : { color: "#173C53", cursor: "pointer" }
              }
              size="sm"
              icon={"arrow-alt-circle-right"}
            />
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(CalendarYearPie);
